import { DateTime } from "luxon";

export const VARIANTS_AGE_FILTER = {
  "16+": "Ages 16+",
  "12-15": "Ages 12-15",
  "Under 12": "140cm+ | Ages under 12",
};

export const ACCORDIAN_EXPERT_RACE = "EXPERT RACE Requirements";
export const ACCORDIAN_DANGEROUS_DRIVING = "ZERO TOLERANCE towards Dangerous Driving";
export const ACCRODIAN_IMPORTANT_INFO = "IMPORTANT INFORMATION ABOUT YOUR RACE";
export const ACCORDIAN_BOOKING_PROTECTION = "BOOKING PROTECTION";
export const ACCORDIAN_REFUND = "REFUND POLICY";
export const ACCORDIAN_ZERO_TOLERANCE_DRUGS = "ZERO TOLERANCE TOWARDS DRUGS AND ALCOHOL";
export const MAX_AVAILABLE_SEATS_MAIN_TRACK = 16;
export const MAX_AVAILABLE_SEATS_MINI_TRACK = 6;

export const autumnDate = (timeFilter: String) => {
  let now = DateTime.now();
  let local = DateTime.local(2023, 5, 4);
  if (timeFilter === "NIGHT") local = DateTime.local(2023, 5, 2);
  let diff = local.diff(now, "days").days;
  return Math.floor(diff);
};

export const winterDate = (timeFilter: String) => {
  let now = DateTime.now();
  let local = DateTime.local(2023, 7, 20);
  if (timeFilter === "NIGHT") local = DateTime.local(2023, 7, 18);
  let diff = local.diff(now, "weeks").weeks;
  return Math.floor(diff);
};

export const springDate = (timeFilter: String) => {
  let now = DateTime.now();
  let local = DateTime.local(2023, 10, 12);
  if (timeFilter === "NIGHT") local = DateTime.local(2023, 10, 10);
  let diff = local.diff(now, "months").months;
  return Math.floor(diff);
};
